import styled, { css } from 'styled-components'
import { Dropdown } from 'common-components'

export const TtsVelocityWrapper = styled.div`
  position: relative;
`

export const DropdownWrapper = styled(Dropdown)<{ $isBulkMode: boolean }>`
  flex-shrink: 0;
  border-radius: 4px;
  & > div {
    padding: 0;
  }
  ${({ $isBulkMode }) =>
    $isBulkMode
      ? css`
          width: 46px;
          height: 46px;
        `
      : css`
          & > div {
            border: none;
            background-color: transparent;
            &:hover {
              &::before {
                content: none;
              }
              border: none;
            }
          }
          width: 50px;
          height: 20px;
        `}
`
